export { default } from "./EventsList";
